import React from 'react';
import { object, mixed } from 'yup';
import { Card, CardFooter, CardBody } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import { Button, Form } from '@cordata/buffet';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import {
  usePatient,
  formikValidate as validate,
} from '~/utils';
import { store } from '~/utils/diagnosis';
import Fields from './Fields';

const validationSchema = object().shape({
  diagnosis: mixed().required(),
  status: mixed().required(),
  provider: mixed().required(),
});

const DiagnosisForm = ({
  data,
  disabled,
  isAdd,
}) => {
  const history = useHistory();
  const [, patient] = usePatient();

  return (
    <Form
      enableReinitialize
      displayName="DiagnosisForm"

      initialValues={{
        ...data,
        patient,
        isAdd,
      }}

      onSubmit={(values, actions) => {
        return validate(values, validationSchema)
          .then((validatedPayload) => {
            const { id, ...v } = validatedPayload;
            const method = id ? store.put : store.post;
            return method({ values: v, id })
              .then(() => toast.success('Successfully Saved!'))
              .then(() => history.push(`/patients/${values.patient.id}/diagnoses`))
              .catch((e) => actions.setErrors({ server: e.errors }));
          })
          .catch(e => {
            actions.setErrors(e);
            actions.setTouched(e); // needed for validation errors to show
          })
          .finally(() => actions.setSubmitting(false));
      }}
    >
      {({
        isSubmitting,
      }) => (
        <Card>
          <CardBody>
            <Fields isAdd={isAdd} disabled={disabled} />
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button
                type="cancel"
                disabled={isSubmitting}
                tag={Link}
                to={`/patients/${patient.id}/diagnoses`}
              >
                Cancel
              </Button>

              {!disabled && (
                <Button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Working ...' : 'Save'}
                </Button>
              )}
            </div>
          </CardFooter>
        </Card>
      )}
    </Form>
  );
};

DiagnosisForm.propTypes = {
  data: PropTypes.shape(),
  disabled: PropTypes.bool,
  isAdd: PropTypes.bool,
};

DiagnosisForm.defaultProps = {
  data: undefined,
  disabled: false,
  isAdd: false,
};

export default DiagnosisForm;
